








































import Vue from "vue";
import { Action, Getter } from "vuex-class";
import { Component, Watch } from "vue-property-decorator";

import { Seminar, SeminarElement } from "@/core/models";
import Sidebar from "../components/Sidebar.vue";
import Content from "../components/Content.vue";

@Component({ components: { Sidebar, Content } })
export default class SeminarDetails extends Vue {
  @Getter("seminars/loading") loading!: boolean;
  @Getter("seminars/selected") seminar?: Seminar;
  @Getter("seminars/element") element?: SeminarElement;

  @Action("seminars/next") next!: () => void;
  @Action("seminars/get") getSeminar!: (d: any) => Promise<void>;

  @Action("displaySnackbar") displaySnackbar!: (m: string) => void;

  @Watch("$route", { immediate: true })
  onRouteChanged() {
    const param = this.$route.params.id as string | undefined;
    if (!param) this.$router.replace("/seminars?from=details");
    else this.getSeminar({ id: Number(param) });
  }
}
